"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.generator = void 0;
const generator = (object, parserOptions) => {
    const separator = (parserOptions === null || parserOptions === void 0 ? void 0 : parserOptions.separator) || '~';
    return separator + decodeURIComponent(new URLSearchParams(object).toString()) + separator;
};
exports.generator = generator;
//# sourceMappingURL=generator.js.map